var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportsGenerate = function SvgReportsGenerate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "reports_generate_svg2__a",
    x1: 4.9,
    x2: 122.6,
    y1: 160.46,
    y2: 27.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#reports_generate_svg2__a",
    id: "reports_generate_svg2__c",
    x1: 10.71,
    x2: 128.41,
    y1: 165.62,
    y2: 33.11
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#reports_generate_svg2__a",
    id: "reports_generate_svg2__d",
    x1: 17.78,
    x2: 135.48,
    y1: 171.9,
    y2: 39.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#reports_generate_svg2__a",
    id: "reports_generate_svg2__e",
    x1: 33.94,
    x2: 151.64,
    y1: 186.26,
    y2: 53.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#reports_generate_svg2__a",
    id: "reports_generate_svg2__f",
    x1: 84.49,
    x2: 202.2,
    y1: 231.16,
    y2: 98.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#reports_generate_svg2__a",
    id: "reports_generate_svg2__g",
    x1: 84.49,
    x2: 202.2,
    y1: 231.16,
    y2: 98.65
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100 186.05H25.58c-3.09 0-6.04-1.23-8.22-3.4-2.18-2.19-3.4-5.13-3.4-8.22V25.58c0-3.09 1.23-6.04 3.4-8.22 2.19-2.18 5.13-3.4 8.22-3.4h76.74v30.23c0 9 7.28 16.28 16.28 16.28h30.23V90.7c0 3.85 3.13 6.98 6.98 6.98s6.98-3.13 6.98-6.98V57.34c0-4.32-1.71-8.46-4.77-11.51L116.96 4.77A16.24 16.24 0 0 0 105.45 0H25.58C18.8 0 12.29 2.7 7.49 7.49A25.63 25.63 0 0 0 0 25.58v148.84c0 6.78 2.7 13.29 7.49 18.09 4.8 4.79 11.31 7.49 18.09 7.49H100c3.85 0 6.98-3.13 6.98-6.98s-3.13-6.98-6.98-6.98Zm38.98-139.54h-20.37c-1.28 0-2.33-1.04-2.33-2.33V23.81z",
    style: {
      fill: "url(#reports_generate_svg2__a)",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.58 86.05c0-3.85-3.13-6.98-6.98-6.98H44.19c-3.85 0-6.98 3.13-6.98 6.98s3.13 6.98 6.98 6.98h74.42c3.85 0 6.98-3.13 6.98-6.98Z",
    style: {
      fill: "url(#reports_generate_svg2__c)",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.05 111.63H44.19c-3.85 0-6.98 3.13-6.98 6.98s3.13 6.98 6.98 6.98h41.86c3.85 0 6.98-3.13 6.98-6.98s-3.13-6.98-6.98-6.98",
    style: {
      fill: "url(#reports_generate_svg2__d)",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.05 144.19H44.19c-3.85 0-6.98 3.13-6.98 6.98s3.13 6.98 6.98 6.98h41.86c3.85 0 6.98-3.13 6.98-6.98s-3.13-6.98-6.98-6.98",
    style: {
      fill: "url(#reports_generate_svg2__e)",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.52,
    cy: 152.33,
    r: 13.95,
    style: {
      fill: "url(#reports_generate_svg2__f)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.33 154.43c.07-1.4.07-2.81 0-4.21l5.23-6.83a7 7 0 0 0 1.07-6.5 48 48 0 0 0-9.18-15.9 6.98 6.98 0 0 0-6.16-2.33l-8.54 1.12a39 39 0 0 0-3.66-2.1l-3.29-7.95a6.96 6.96 0 0 0-5.1-4.17 47.7 47.7 0 0 0-18.36 0c-2.29.45-4.2 2.01-5.1 4.17l-3.3 7.95c-1.26.63-2.47 1.34-3.66 2.11l-8.53-1.13c-2.32-.3-4.62.58-6.16 2.33a47.5 47.5 0 0 0-9.18 15.9c-.75 2.2-.35 4.65 1.06 6.5l5.24 6.84c-.07 1.4-.07 2.81 0 4.21l-5.24 6.83a7.02 7.02 0 0 0-1.06 6.5c2 5.84 5.12 11.25 9.18 15.9a6.97 6.97 0 0 0 6.16 2.33l8.54-1.12c1.17.76 2.4 1.47 3.66 2.1l3.29 7.95a6.96 6.96 0 0 0 5.1 4.17c6.07 1.19 12.3 1.19 18.36 0 2.29-.45 4.2-2.01 5.1-4.17l3.3-7.95a39 39 0 0 0 3.66-2.11l8.53 1.13c2.31.3 4.62-.58 6.16-2.33a47.85 47.85 0 0 0 9.18-15.9c.75-2.2.35-4.65-1.07-6.5zm-14.11-5.37c.28 2.17.28 4.36 0 6.53a6.98 6.98 0 0 0 1.38 5.16l4.47 5.84a34 34 0 0 1-2.91 5.05l-7.3-.96c-1.83-.23-3.69.26-5.15 1.39a24.7 24.7 0 0 1-5.67 3.27 7.02 7.02 0 0 0-3.78 3.77l-2.83 6.8c-1.93.18-3.89.18-5.82 0l-2.83-6.8a7.02 7.02 0 0 0-3.78-3.77c-2.03-.84-3.93-1.93-5.67-3.27a7 7 0 0 0-5.15-1.39l-7.3.96a33 33 0 0 1-2.91-5.04l4.47-5.85a6.98 6.98 0 0 0 1.38-5.16c-.29-2.17-.29-4.36 0-6.53a6.98 6.98 0 0 0-1.38-5.16l-4.47-5.84c.82-1.77 1.8-3.45 2.91-5.05l7.3.96c1.83.23 3.69-.26 5.15-1.39 1.74-1.34 3.64-2.44 5.67-3.27a7.02 7.02 0 0 0 3.78-3.77l2.83-6.8c1.93-.18 3.89-.17 5.82 0l2.83 6.8c.71 1.7 2.07 3.06 3.78 3.77 2.02.84 3.93 1.93 5.67 3.27a7 7 0 0 0 5.15 1.39l7.3-.96a33.7 33.7 0 0 1 2.91 5.04l-4.47 5.85a6.98 6.98 0 0 0-1.38 5.16",
    style: {
      fill: "url(#reports_generate_svg2__g)",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
};
export default SvgReportsGenerate;